// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Offer20CircleFilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Offer20CircleFilled: FC<Offer20CircleFilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M16.212 8.837c-.212.213-.47.32-.774.32-.304 0-.563-.107-.775-.32a1.055 1.055 0 0 1-.32-.774c0-.304.107-.563.32-.775.212-.213.47-.32.774-.32.304 0 .563.107.775.32.213.212.32.47.32.774 0 .304-.107.563-.32.775Z" />
            <path
                d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Zm-1.557-5.091a1.359 1.359 0 0 0 .984 0c.158-.06.304-.158.438-.292l6.258-6.258c.072-.072.134-.149.184-.23a1.16 1.16 0 0 0 .102-.2c.06-.156.091-.321.091-.494V6.312c0-.36-.128-.67-.386-.926A1.264 1.264 0 0 0 17.187 5h-5.122c-.169 0-.333.03-.491.091a1.174 1.174 0 0 0-.251.133 1.35 1.35 0 0 0-.183.153l-6.257 6.259a1.28 1.28 0 0 0-.292.428 1.29 1.29 0 0 0-.091.483c0 .166.03.33.092.49.06.16.158.307.29.44l5.123 5.14c.072.072.148.134.227.185.068.043.138.079.21.107Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Offer20CircleFilled;
